import React, {useState, useEffect} from 'react'
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col, Input } from 'reactstrap';
// import axios from 'axios';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import renderSelectField from '@/shared/components/form/Select'
import axios from 'axios'
import getStatesByCountry from "@/services/getStatesByCountry";
import {labelizeNamedData} from '@/shared/helpers'

const CopySubProgramModal = ({isOpen, setOpen, toggle, program, theme, subprogramList, rtl}) => {
    const [loading, setLoading] = useState(false)
    const [sourceProgram, setSourceProgram] = useState(program)
    const [programId, setProgramId] = useState(program.id)
    const [domainOptions, setDomainOptions] = useState(null);
    const [defaultDomain, setDefaultDomain] = useState(null);
    const [selectedProgram, setSelectedProgram]= useState({label:program.name, value: program.id});

    const [states, setStates] = useState(null)
    const [initialValues, setInitialValues]= React.useState({
        name: program.name,
    })

    useEffect(() => {
        if( program.organization_id ){
            getStatesByCountry(223)
            .then( result => {
                setStates(labelizeNamedData(result))
            })
        }
    }, [program]);

    useEffect(() => {
        if(selectedProgram){
            const url = `/organization/${program.organization_id}/program/${selectedProgram?.value}`
            axios.get(url)
                .then((res) => {
                    if(res.status === 200)  {
                        const programData  =  res?.data;
                        if (!domainOptions) {
                            let options = [];
                            if(!defaultDomain && res.data?.default_domain && res.data?.default_domain.length > 0){
                                setDefaultDomain({'label': res.data?.default_domain[0].name, 'value': res.data?.default_domain[0].id});
                            }
                            res.data?.domains.map( (domain, i) => {
                                options.push({'label': domain.name, 'value': '' + domain.id})
                            });
                            setDomainOptions(options)
                        }
                        setInitialValues({
                            name: programData?.name || '',
                            address: programData?.address, external_id: programData?.external_id,
                            parent_id: programData?.id
                            // Add other expected fields
                        });
                        
                        setSourceProgram(programData);
                    }
                })
                .catch( error => {
                    setLoading(false)
                })
        }
    }, [selectedProgram]);

    const onChangeDefaultDomain = (value) => {
        setDefaultDomain(value);
    }

    const onSubmitCopyForm = values => {
        setLoading(true)
        sourceProgram.source_program_id  = programId;
        sourceProgram.parent_id = programId;
        sourceProgram.name = values.name;
        sourceProgram.clone_email_template  = values?.clone_email_template;
        sourceProgram.copy_event_template   = values?.copy_event_template;
        sourceProgram.copy_program_template = values?.copy_program_template;
        sourceProgram.add_program_manager  = values?.add_program_manager;
        sourceProgram.default_domain        = values?.default_domain?.value;
        sourceProgram.external_id           = values.external_id;

        if(sourceProgram.user_claim_expire_after_days === null)
            sourceProgram.user_claim_expire_after_days = 0; 

        if(values?.address){
            sourceProgram.address ={        
                address: values?.address?.address,
                address_ext: values?.address?.address_ext,
                city: values?.address?.city,
                zip: values?.address?.zip,
                state_id: values?.address?.state_id,
                country_id: values?.address?.country_id
            } ;
        }
        delete sourceProgram?.program_extras;
        delete sourceProgram?.program_transaction_fee;
        delete sourceProgram.id;
        delete sourceProgram.status;
        delete sourceProgram.account_holder_id;
        axios.post(`/organization/${sourceProgram.organization_id}/program`, sourceProgram)
        .then( (res) => {
            if(res.status == 200)  {
                setLoading(false)
                window.location = "/manager/manage/subprograms?message=Program copied successfully!";
            }
        })
        .catch( error => {
            setLoading(false)
        })
    }

    const validate = values => {
        let errors = {};
        if (!values.name) {
            errors.name = "Program name is required";
        }
        return errors;
    }

    if( !program ) return 'Loading...'

    return (
    <Modal className={`modal-program manager-program-modal modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="div" className="manager-program-modal__header">
            <div className="manager-program-modal__header-row">
                <div className="manager-program-modal__header-copy">
                    <h3 className="manager-program-modal__title">Clone Subprogram</h3>
                    <p className="manager-program-modal__subtitle">
                        Copy an existing program setup into a new child program.
                    </p>
                </div>
                <ButtonToolbar className="manager-program-modal__actions">
                    <Button outline color="primary" onClick={toggle}>Close</Button>
                </ButtonToolbar>
            </div>
        </ModalHeader>
        <ModalBody className="manager-program-modal__body">
            <Form
                onSubmit={onSubmitCopyForm}
                validate={validate}
                initialValues={initialValues}
            >
            {({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="manager-program-modal__form-head">
                        <h4 className="manager-program-modal__form-title">Program Copy Settings</h4>
                        <p className="manager-program-modal__form-copy">
                            Select the source program details, optional templates, and destination information.
                        </p>
                    </div>
                    
                    <div className="form__form-group">
                        <span className="form__form-group-label">Select Subprogram </span>
                        <div className="form__form-group-field">
                            <Field
                                name="parent_id"
                                options={subprogramList}
                                component={renderSelectField}
                                parse={(value) => {
                                    setSelectedProgram(value);
                                    return value;
                                }}
                            />
                        </div>
                    </div>
                    <Field name="name">
                        {({ input, meta }) => (
                            <div className="form__form-group mt-3">
                                <span className="form__form-group-label">Program name</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                        <Input type="text" {...input} placeholder="Program name" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Field>
                   
                    <Field name="external_id ">
                        {({ input, meta }) => (
                            <div className="form__form-group mt-3">
                                <span className="form__form-group-label">External ID</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                        <Input type="text" {...input}  placeholder="External ID" />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Field>  

                    <div className="form__form-group mt-3">
                        <span className="form__form-group-label">Default Domain</span>
                        <div className="form__form-group-field">
                            <Field
                                name="default_domain"
                                options={domainOptions}
                                initialValue={defaultDomain?.value}
                                component={renderSelectField}
                                parse={(value) => {
                                    onChangeDefaultDomain(value);
                                    return value;
                                }}
                            />
                        </div>
                    </div>

                    <div className="form__form-group mt-3">
                        <div className="form__form-group-field">
                            <Field
                                name="add_program_manager"
                                type="checkbox"
                                component={renderCheckBoxField}
                                label={"Add this program`s Managers to new program"}
                            />
                        </div>
                    </div>
                    
                    <h5 className='manager-program-modal__section-title mt-4'>Template Settings</h5>
                    <div className="form__form-group ">
                        <div className="form__form-group-field">
                            <Field
                                name="clone_email_template"
                                type="checkbox"
                                component={renderCheckBoxField}
                                label={"Clone Email Templates"}
                            />
                        </div>
                    </div>
                    
                    <div className="form__form-group mt-2">
                        <div className="form__form-group-field">
                            <Field
                                name="copy_event_template"
                                type="checkbox"
                                component={renderCheckBoxField}
                                label={"Copy Event Templates from this program"}
                            />
                        </div>
                    </div>
                    <div className="form__form-group mt-2">
                        <div className="form__form-group-field">
                            <Field
                                name="copy_program_template"
                                type="checkbox"
                                component={renderCheckBoxField}
                                label={"Copy Program Templates from this program"}
                            />
                        </div>
                    </div>

                    <h5 className='manager-program-modal__section-title mt-4'>Address Settings</h5>
                    <Row className='w100'>
                        <Col md="6" lg="6" xl="6">
                            <Field name="address.address">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Address</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Input type="text" {...input} placeholder="Address" />
                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                            )}
                            </Field>  
                        </Col>
                        <Col md="6" lg="6" xl="6">
                            <Field name="address.address_ext">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Address line 2</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Input type="text" {...input} placeholder="Address line 2" />
                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                            )}
                            </Field>  
                        </Col>
                    </Row>
                    <Row className='w100'>
                        <Col md="6" lg="4" xl="4">
                            <Field name="address.city">
                                {({ input, meta }) => (
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">City</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <Input type="text" {...input} placeholder="City" />
                                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Field>  
                        </Col>
                        <Col md="6" lg="4" xl="4">
                            <Field name="address.zip">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Zip</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Input type="text" {...input} placeholder="Zip" />
                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                            )}
                            </Field>  
                        </Col>
                        <Col md="6" lg="4" xl="4">
                            <div className="form__form-group">
                                <span className="form__form-group-label">State</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="address.state_id"
                                        component={renderSelectField}
                                        options={states}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="manager-program-modal__footer-actions">
                        <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">
                            Confirm Copy
                        </Button>
                    </div>
                </form>
            )}
            </Form>
        </ModalBody>
    </Modal>
    )
}

CopySubProgramModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};
  
export default connect((state) => ({
    theme: state.theme,
    rtl: state.rtl
}))(CopySubProgramModal);
